import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Heaven is where your code lies",
  "description": "",
  "published": "2009-12-07T00:00:00.000Z",
  "redirect_from": ["/blog/heaven-is-where-your-code-lies/swizec/938"],
  "categories": "intrigues, life, Programmer, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here I am at `}<a parentName="p" {...{
        "href": "http://www.hekovnik.si/"
      }}>{`Hekovnik`}</a>{`, alone in the romantic ambient of spotlights, whiteboards and loud music that makes me just wanna code code code. Yep, it's Iron Maiden, felt like it, and son, I am not disappoint.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/15af187398c7b780dc84289869c95f10.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/15af187398c7b780dc84289869c95f10.jpeg",
          "alt": "Romantic ambient",
          "title": "Romantic ambient"
        }}></img></a></p>
    <p>{`Lounging on the sofa, with my trusty MacBook in lap, shiny logo greeting anyone daring to enter my bubble of deep concentration and flowing code masterpieces.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/IMG00077.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/IMG00077.jpg",
          "alt": "IMG00077",
          "title": "IMG00077"
        }}></img></a></p>
    <p>{`It's time like these that I truly love what I do, I know us developers are a fussy bunch and like to get all up in arms over the littlest thing that upsets us. That we love nothing better than to nag about some app or another taking 10 fucking milliseconds too long to open! The travesty!`}</p>
    <p>{`But fact remains, I love being programmer, despite stupid tests not passing, despite frequent choices not to use testing that end up biting us in the arse, despite always changing design specs, despite all the bugs and all the weird shit and that little typo that brings the whole system to its knees and takes a week to fix ...`}</p>
    <p>{`... `}<strong parentName="p">{`heaven really is where your code lies`}</strong>{`, because code is an expression of one's self, because code is art and no matter what anyone ever says, I will continue to see myself more as a poet than an engineer.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/21b2ca9e-5017-41d3-b54b-50c7e9d71734/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=21b2ca9e-5017-41d3-b54b-50c7e9d71734",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      